import React, {useEffect} from 'react';
import {isConfirmationCodeUsed} from '../../screens/profile/common/model';
import {useDispatch} from 'react-redux';
import {confirmContactsChange} from '../../redux/actions/profile';
import {addNotification} from '../../redux/actions/snackbar';
import {SnackbarNotificationType} from '../components/snackbar/model';

export const useConfirmEmail = (
  isEmailConfirmationNeeded: boolean,
  code: string,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const dispatch = useDispatch();
  useEffect(() => {
    const confirmingNewEmail = async () => {
      const isCodeUsed = await isConfirmationCodeUsed();
      if (isEmailConfirmationNeeded && isCodeUsed === 'unUsed') {
        try {
          dispatch(confirmContactsChange(code));
          dispatch(
            addNotification({
              message: 'Новая эл. почта успешно сохранена.',
              type: SnackbarNotificationType.Success,
            }),
          );
        } catch (err) {
          let errorText = err.data?.[0]?.message || err.message || 'Ссылка недействительна';
          dispatch(
            addNotification({
              message: errorText,
              type: SnackbarNotificationType.Error,
            }),
          );
        }
      }
      setIsLoading(false);
    };
    confirmingNewEmail();
  }, [isEmailConfirmationNeeded]);
};
